const WS_URL = process.env.REACT_APP_WS_URL || "wss://adani-cimapv3.onrender.com/ws/dashboard";

export function connectDashboardWS({ onMessage, onOpen, onClose }) {
  let ws = null;
  let closed = false;
  let retryCount = 0;
  const MAX_RETRIES = 5;

  const connect = () => {
    if (closed || retryCount >= MAX_RETRIES) return;

    try {
      ws = new WebSocket(WS_URL);

      ws.onopen = () => {
        retryCount = 0;
        if (onOpen) onOpen({ mock: false });
      };

      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          onMessage && onMessage(data);
        } catch (err) {
          onMessage && onMessage({ event: "RAW", payload: e.data });
        }
      };

      ws.onclose = () => {
        if (!closed) {
          retryCount++;
          setTimeout(connect, 2000 * retryCount); // Exponential backoff
        }
        if (onClose) onClose();
      };

      ws.onerror = () => {
        ws.close();
      };
    } catch (e) {
      console.error("WS Connection Failed", e);
    }
  };

  connect();

  return {
    close: () => {
      closed = true;
      if (ws && ws.readyState === WebSocket.OPEN) ws.close();
    },
    isMock: () => false,
  };
}
